<template>
  <div class="eemo-page-shell" style="background: white;">
  <div class="tnc-body">
    <img class="support-logo" src="https://storage.googleapis.com/menus-275719.appspot.com/logos/SMTM-logo_300x300.png" alt="Show Me The Menu">
    <h5>Booking support</h5>
    <p>
      Send a message about a reservation you made through Show Me The Menu.
      Use the email address from the booking, and the restaurant you booked.
    </p>

    <p v-if="sent" class="support-note">Your message has been sent. We will reply to the email address on the booking.</p>
    <p v-if="error" class="support-error">{{ error }}</p>

    <form v-if="!sent" class="support-form" @submit.prevent="submit">
      <label>
        Email <span class="req">*</span>
        <input v-model.trim="form.email" type="email" required maxlength="200" autocomplete="email"
               placeholder="The email you used when you booked">
      </label>
      <label>
        Name
        <input v-model.trim="form.name" type="text" maxlength="200" autocomplete="name">
      </label>
      <label>
        Contact
        <input v-model.trim="form.contact" type="text" maxlength="80" autocomplete="tel" placeholder="Phone number">
      </label>
      <label>
        Restaurant <span class="req">*</span>
        <input v-model.trim="form.restaurant" type="text" required maxlength="200" :readonly="restaurantLocked"
               placeholder="The restaurant you booked">
      </label>
      <label>
        Booking date
        <input v-model="form.bookingDate" type="date">
      </label>
      <label>
        Booking time
        <input v-model="form.bookingTime" type="time">
      </label>
      <label>
        Message <span class="req">*</span>
        <textarea v-model.trim="form.message" required maxlength="4000" rows="6" placeholder="Describe the issue"></textarea>
      </label>
      <button type="submit" :disabled="sending">{{ sending ? 'Sending…' : 'Send message' }}</button>
    </form>
    <p class="support-company">
      Show Me The Menu is a brand of <b>Borium Studio Limited</b><br>
      Company number 10047282<br>
      Unit 68, Trident Court, 1 Oakcroft Road, Chessington KT9 1BD, United Kingdom
    </p>
  </div>
  </div>
</template>

<script>
import {getBookingSupportRestaurant, submitBookingSupport} from "../api/borium";

export default {
  name: "BookingSupport",
  data() {
    return {
      form: {
        email: "",
        name: "",
        contact: "",
        restaurant: "",
        merchantId: 0,
        bookingDate: "",
        bookingTime: "",
        message: ""
      },
      restaurantLocked: false,
      sending: false,
      sent: false,
      error: ""
    }
  },
  created() {
    const query = this.$route.query || {};
    this.form.email = query.email || "";
    this.form.name = query.name || "";
    this.form.contact = query.contact || "";
    this.form.restaurant = query.restaurant || "";
    this.form.bookingDate = query.date || "";
    this.form.bookingTime = query.time || "";
    const merchantId = parseInt(query.merchantId || query.id || "0", 10);
    if (merchantId > 0) {
      this.form.merchantId = merchantId;
      this.loadRestaurant(merchantId);
    }
  },
  methods: {
    loadRestaurant(merchantId) {
      const self = this;
      getBookingSupportRestaurant(merchantId)
        .then(function (data) {
          if (data && data.success && data.item && data.item.title) {
            self.form.restaurant = data.item.title;
            self.form.merchantId = data.item.id;
            self.restaurantLocked = true;
          }
        })
        .catch(function () {
        });
    },
    submit() {
      this.error = "";
      this.sending = true;
      const self = this;
      submitBookingSupport(this.form)
        .then(function (data) {
          self.sending = false;
          if (data && data.success) {
            self.sent = true;
          } else {
            self.error = (data && data.message) ? data.message : "Could not send the message.";
          }
        })
        .catch(function () {
          self.sending = false;
          self.error = "Could not send the message. Please try again.";
        });
    }
  }
}
</script>

<style scoped>
.tnc-body {
  max-width: 760px;
  margin: 24px auto;
  padding: 0 16px 48px;
  color: #333;
  line-height: 1.5;
}
.support-logo {
  display: block;
  width: 72px;
  height: 72px;
  margin: 8px auto 12px;
}
.support-form {
  text-align: left;
}
.support-form label {
  display: block;
  margin: 14px 0;
  font-weight: 600;
  text-align: left;
}
.support-form input,
.support-form textarea {
  display: block;
  width: 100%;
  margin-top: 6px;
  padding: 8px 10px;
  font-weight: 400;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
.support-form input[readonly] {
  background: #f4f4f4;
}
.support-form button {
  margin-top: 8px;
  padding: 10px 18px;
  background: #EF5C29;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
}
.support-form button:disabled {
  opacity: 0.6;
  cursor: default;
}
.req {
  color: #c62828;
}
.support-note {
  padding: 12px;
  background: #e8f5e9;
  border-radius: 4px;
}
.support-error {
  padding: 12px;
  background: #ffebee;
  border-radius: 4px;
  color: #c62828;
}
.support-company {
  margin-top: 28px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  text-align: left;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingSupport.vue